import React, { useEffect } from "react";
import { fetchEventBanner, fetchEventData } from "../api/EventApi";
import { dynamicFailed } from "../hooks/useToast";
import EventBanner from "../components/event/EventBanner";
import { useLoader } from "../context/LoaderContext";
import AllEvents from "../components/event/AllEvents";
import { useEventContext } from "../context/EventContext";
import { useEventBannerContext } from "../context/EventBannerContext";

const Events = () => {
  const { setLoading } = useLoader();
  const { eventData, setEventData } = useEventContext();
  const { eventBannerData, setEventBannerData } = useEventBannerContext();

  useEffect(() => {
    setLoading(true);
    if (eventData.length === 0 || eventBannerData.length === 0) {
      Promise.all([fetchEventData(), fetchEventBanner()])
        .then(([eventData, eventBannerData]) => {
          setEventData(eventData);
          setEventBannerData(eventBannerData);
          setTimeout(() => {
            setLoading(false);
          }, 1000);
        })
        .catch(() => {
          setTimeout(() => {
            setLoading(false);
          }, 1000);
          dynamicFailed("Server Error");
        });
    } else {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  }, [
    eventBannerData.length,
    eventData.length,
    setEventBannerData,
    setEventData, 
    setLoading, 
  ]);
  return (
    <>
      <EventBanner eventBannerData={eventBannerData} />
      <AllEvents />
    </>
  );
};

export default Events;
